module.exports = {"id":"dp3_3l3q3","text":"Copyright and licences","instructions":"Which scenario is an ethical concern in AI model training?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l3q3-a1","text":"Using copyrighted data without consent","score":3.7},{"id":"dp3_3l3q3-a2","text":"Training on open datasets","score":1.3},{"id":"dp3_3l3q3-a3","text":"Labelling generated outputs","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l3q3.json
// module id = 1162
// module chunks = 41